/* All the types used by the API connector actions */

export const REQUEST_CREATE = Symbol('REQUEST_CREATE');
export const REQUEST_RETRIEVE = Symbol('REQUEST_RETRIEVE');
export const REQUEST_LIST = Symbol('REQUEST_LIST');
export const REQUEST_TOTAL_COUNT = Symbol('REQUEST_TOTAL_COUNT');
export const REQUEST_UPDATE_ONE = Symbol('REQUEST_UPDATE_ONE');
export const REQUEST_MANY = Symbol('REQUEST_MANY');
export const REQUEST_DELETE_ONE = Symbol('REQUEST_DELETE_ONE');
export const SET_CURRENT_ID = Symbol('SET_CURRENT_ID');
export const SET_CURRENT = Symbol('SET_CURRENT');
export const RESET = Symbol('RESET');
export const SET_SEARCH = Symbol('SET_SEARCH');
export const CLEAR_SEARCH = Symbol('CLEAR_SEARCH');
export const SET_QUERY = Symbol('SET_QUERY');
export const CLEAR_QUERY = Symbol('CLEAR_QUERY');
export const NEXT_PAGE = Symbol('NEXT_PAGE');
